import DefaultModal from '../../../../../components/Modal/DefaultModal';
import React, { useCallback } from 'react';
import InputsForContacts from '../../../Contact/form/InputsForContacts/index';

const EditContactModal = ({
  isModalOpen,
  onModalToggle,
  contact,
  recordTypeId,
  setSelectedClient,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);

  if (!contact || !recordTypeId) {
    return null;
  }

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      size="md"
      title="Alterar Contato"
      showCloseButton={false}
      modalContainerClasses="modal-md"
      {...props}
    >
      <div>
        <InputsForContacts
          recordTypeId={recordTypeId}
          contact={contact}
          closeModal={closeModal}
          editContact={true}
          setSelectedClient={setSelectedClient}
        />
      </div>
    </DefaultModal>
  );
};

export default EditContactModal;
